import { create } from 'zustand'

interface UiState {
  // Mobile chat overlay state
  isMobileChatOverlayOpen: boolean
  setMobileChatOverlayOpen: (isOpen: boolean) => void

  // Other UI states can be added here in the future
  sidebarOpen?: boolean
  setSidebarOpen?: (isOpen: boolean) => void
}

export const useUiStore = create<UiState>((set) => ({
  // Mobile chat overlay
  isMobileChatOverlayOpen: false,
  setMobileChatOverlayOpen: (isOpen: boolean) => set({ isMobileChatOverlayOpen: isOpen }),

  // Future UI states can be initialized here
}))